import React from 'react';
import { Form, Input, InputNumber, Modal, Radio } from 'antd';
import { PostStatus } from '../../_services/service'
export function PostForm(props) {
    const { visible, onCancel, onCreate, onUpdate, loading, record, title, } = props;
    const [form] = Form.useForm();
    const handleSubmit = () => {
        form.validateFields().then((values) => {
            if (record) {
                onUpdate &&
                    onUpdate(Object.assign(Object.assign({}, values), { id: record.id }));
            }
            else {
                onCreate && onCreate(values);
            }
        });
    };
    // 初始化表单
    React.useEffect(() => {
        if (!visible) {
            return;
        }
        form.setFieldsValue({
            title: record === null || record === void 0 ? void 0 : record.title,
            content: record === null || record === void 0 ? void 0 : record.content,
            status: record ? record.status : PostStatus.Draft,
            order: (record === null || record === void 0 ? void 0 : record.order) || 1,
        });
    }, [record, form, visible]);
    return (<Modal 
    // @see https://ant.design/components/form-cn/#FAQ
    forceRender title={title} open={visible} onCancel={onCancel} onOk={handleSubmit} okButtonProps={{ loading }}>
      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
        <Form.Item name='title' label='title' rules={[
            {
                required: true,
                message: 'title is required',
            },
        ]}>
          <Input></Input>
        </Form.Item>
        <Form.Item name='content' label='content' rules={[
            {
                required: true,
                message: 'content is required',
            },
        ]}>
          <Input.TextArea></Input.TextArea>
        </Form.Item>
        <Form.Item name='status' label='status' required>
          <Radio.Group>
            <Radio value={PostStatus.Draft}>draft</Radio>
            <Radio value={PostStatus.Published}>published</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name='order' label='order' rules={[
            {
                required: true,
                message: 'order is required',
            },
        ]}>
          <InputNumber min={1}></InputNumber>
        </Form.Item>
      </Form>
    </Modal>);
}
